import Swal from "sweetalert2";

export default async function AlertConfirm(title, textConfirm) {
    return await Swal.fire({
        icon: "info",
        title: title,
        text: textConfirm,
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        confirmButtonColor: `#6366F1`,
    })
}